import React, { useEffect } from 'react';
import { Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';

const ReviewOutput = ({ feedback, isLoading }) => {
  const { t } = useTranslation();
  useEffect(() => {
    if (!isLoading && feedback) {
      if (window.Prism) {
        window.Prism.highlightAll();
      }
    }
  }, [feedback, isLoading]);

  const renderContent = () => {
    if (isLoading) {
      return (
        <div className="flex flex-col items-center justify-center h-full text-slate-400">
          <svg className="animate-spin h-10 w-10 mb-4 text-cyan-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <p className="text-lg font-semibold">{t('Gemini is thinking...')}</p>
          <p className="text-sm">{t('Analyzing your code for quality and improvements.')}</p>
        </div>
      );
    }

    if (!feedback) {
      return (
        <div className="flex flex-col items-center justify-center h-full text-center text-slate-500">
          <Sparkles className="w-16 h-16 mb-4 text-slate-600" />
          <h3 className="text-xl font-semibold text-slate-400">{t('Ready for Review')}</h3>
          <p>{t('Your code review feedback will appear here once you submit your code.')}</p>
        </div>
      );
    }

    return (
       <div className="prose prose-invert prose-sm sm:prose-base max-w-none prose-pre:bg-slate-900/50 prose-pre:border prose-pre:border-slate-700 prose-headings:text-slate-100 prose-a:text-cyan-400 hover:prose-a:text-cyan-300">
        <ReactMarkdown>{feedback}</ReactMarkdown>
      </div>
    );
  };

  return (
    <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-6 h-full overflow-y-auto">
      {renderContent()}
    </div>
  );
};

export default ReviewOutput;

